//export const domain = "http://127.0.0.1:8000"
export const domain = "https://api.eventplots.com"